import { render, staticRenderFns } from "./AttorneyTable.vue?vue&type=template&id=3bc58523&scoped=true&"
import script from "./AttorneyTable.vue?vue&type=script&lang=js&"
export * from "./AttorneyTable.vue?vue&type=script&lang=js&"
import style0 from "./AttorneyTable.vue?vue&type=style&index=0&id=3bc58523&prod&lang=css&"
import style1 from "./AttorneyTable.vue?vue&type=style&index=1&id=3bc58523&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc58523",
  null
  
)

export default component.exports